import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFooter, useHeader } from '../../hooks/useAppLayout';
import ErrorTemplate from '../../templates/Error';
var Error = function Error(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var headerProps = useHeader();
  var footerProps = useFooter();
  var layoutProps = {
    theme: {
      maxWidth: 640,
      contentPosition: 'middle'
    }
  };
  var feedbackProps = {
    text: t('404_message'),
    actions: [{
      link: '/',
      label: t('back_to_home')
    }]
  };
  var errorTemplateProps = _objectSpread({
    headerProps: headerProps,
    footerProps: footerProps,
    layoutProps: layoutProps,
    feedbackProps: feedbackProps
  }, props);
  return /*#__PURE__*/React.createElement(ErrorTemplate, errorTemplateProps);
};
Error.propTypes = {};
Error.defaultProps = {};
export default Error;